export const adasDmsRows = {
  SCSABP: [
    { label: 'Forward Collision Warning', key: 'forward_collision' },
    { label: 'Lane Departure Warning', key: 'road_departure' },
    { label: 'Overspeed Alert', key: 'overspeed_adas' },
    { label: 'Collision Warning', key: 'pedestrian_collision' },
  ],
  SCSDBP: [
    { label: 'Kamera Tertutup', key: 'coverning_camera' },
    { label: 'Merokok', key: 'smoke' },
    { label: 'Memainkan Handphone', key: 'phone_call' },
    { label: 'Mata Terpejam', key: 'closed_eyes' },
    { label: 'Tanpa sabuk pengaman', key: 'fasten_seat_belt' },
    { label: 'Menguap', key: 'yawn' },
  ],
}
